import { Button, Card, CircularProgress, Stack, Typography } from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  growthToolFormSchema,
} from '../ZodValidationSchema'
import type { GrowthToolFormValues } from '../ZodValidationSchema'
import { FormBlock } from '../../../../common/FormGenerator'
import { getFormConfig } from './settingsConfig'
import { CardStyle, TypStyle } from './style'

type GrowthToolFormProps = {
  onSubmitDraft: (data: GrowthToolFormValues) => void
  isLoading: boolean
}

export const GrowthToolForm = ({ onSubmitDraft, isLoading }: GrowthToolFormProps) => {
  const methods = useForm<GrowthToolFormValues>({
    mode: 'onBlur',
    resolver: zodResolver(growthToolFormSchema),
    defaultValues: {
      title: '',
      description: '',
      image: '',
      source_type: [],
      content_type: [],
    },
  })

  const { handleSubmit } = methods

  return (
    <Stack alignItems="center" pt={{ xs: '15px', md: '50px' }} px={1.5}>
      <FormProvider {...methods}>
        <Stack gap={2} maxWidth={{ xs: "736px", md: "840px" }} width="100%">
          <Typography variant="h1" px={{ xs: 0, md: 2.5 }}>
            Создание инструмента личностного роста
          </Typography>
          <Card variant="primaryAdaptiveCard" sx={CardStyle}>
            <Typography variant="black-16-semiBold" component="div" sx={TypStyle}>
                Изображение
            </Typography>
            <FormBlock formFieldConfig={getFormConfig('image')} />
          </Card>
          <Card variant="primaryAdaptiveCard" sx={CardStyle}>
            <Typography variant="black-16-semiBold" component="div" sx={TypStyle}>
              Название
            </Typography>
            <FormBlock formFieldConfig={getFormConfig('title')} />
          </Card>
          <Card variant="primaryAdaptiveCard" sx={CardStyle}>
            <Typography variant="black-16-semiBold" component="div" sx={TypStyle}>
              Описание
            </Typography>
            <FormBlock formFieldConfig={getFormConfig('description')} />
          </Card>
          <Card variant="primaryAdaptiveCard" sx={CardStyle}>
            <Typography variant="black-16-semiBold" component="div" sx={TypStyle}>
              Происхождение материала
            </Typography>
            <FormBlock formFieldConfig={getFormConfig('source_type')} />
          </Card>
          <Card variant="primaryAdaptiveCard" sx={CardStyle}>
            <Typography variant="black-16-semiBold" component="div" sx={TypStyle}>
              Формат материала
            </Typography>
            <FormBlock formFieldConfig={getFormConfig('content_type')} />
          </Card>

          <Stack direction="row" spacing={1}>
            <Button
              variant="action"
              onClick={handleSubmit(onSubmitDraft)}
              disabled={isLoading}
            >
              {isLoading ? (
                <Stack direction="row" alignItems="center" spacing={1}>
                  <CircularProgress size={16} color="inherit" />
                  <span>Сохранение...</span>
                </Stack>
              ) : (
                'Создать'
              )}
            </Button>
          </Stack>
        </Stack>
      </FormProvider>
    </Stack>
  )
}
